import * as React from "react";
import * as Highcharts from 'highcharts';
//import drilldown from 'highcharts-drilldown';
import * as AuthStore from "../store/Auth";
import { Helmet } from "react-helmet";
import { connect } from "react-redux";
import { ApplicationState } from '../store';
import { fetchData } from '../utils';
import { busyGif } from '../img';
import { Card, Row, Col } from 'antd';


type AuthProps =
    AuthStore.AuthState // ... state we've requested from the Redux store
    & typeof AuthStore.actionCreators // ... plus action creators we've requested

class Dashboard extends React.Component<AuthProps>
{
    public state =
    {
        labresult: false,
        linelist: false,
        loading: false,

        filter: { state: '', site: '', startDate: null, endDate: null, },
            dashboard: { patients: 0, active: 0, sites: [], inactive: 0, activeSites: 0, newPatients: 0, loss: 0, eligible: 0, tested: 0, patientsYearGroup: [], suppressed: 0, unsuppressed: 0 },
        user: { id: '', firstName: '', lastName: '', email: '', isAuthenticated: false, code: -1, userName: '', role: '', message: '' }
    };
    
    //async componentDidMount()
    //{
    //    let sts = localStorage.getItem("states");
    //    if (!sts)
    //    {
    //        let res = await fetchData('/api/Site/getAllStates');
    //        localStorage.setItem('states', JSON.stringify(res));
    //    }    
    //}

    public stateNames = [{ code: 'KD', name: 'KADUNA' }, { code: 'KG', name: 'KOGI' }, { code: 'GB', name: 'GOMBE' }, {code: 'LG', name: 'LAGOS'}];

    public ageGroup = { ageGroup: '', ageCount: 0 };
    ////@ts-ignore
    async UNSAFE_componentWillMount()
    {
        let sts = localStorage.getItem("states");       
        if (!sts)
        {
            localStorage.setItem('states', JSON.stringify(this.stateNames));
        }

        this.getStats();  
    }    

    componentDidMount()
    {
        //drilldown(Highcharts);        
    }

    activityWatcher()
    {
        let el = this;
        //15 minutes. 60 x 5 = 900 seconds.
        var idleTimeOut = (60 * 15 * 1000);

        //Refresh the Dashboard every 15 minutes.
        setInterval(async function ()
        {            
            el.getStats();

        }, idleTimeOut);

    }

    async getStats()
    {
        let el = this;
        this.setState({ loading: true });
        let res = await fetchData(`/api/Stats/getPublicDashboardStats`);           
        let dashboard = el.state.dashboard;
        dashboard.patients = res.patients;
        dashboard.sites = res.sites;
        dashboard.active = res.active;
        dashboard.inactive = res.inactive;
        dashboard.newPatients = res.newPatients;
        dashboard.tested = res.tested;
        dashboard.suppressed = res.suppressed
        dashboard.unsuppressed = res.unsuppressed;
        dashboard.eligible = res.eligible;

        el.setState({ dashboard });
               
        if (res.sites && res.sites.length > 0)
        {
            localStorage.removeItem('sites');
            localStorage.setItem('sites', JSON.stringify(res.sites));
        }

        var url1 = `/api/Stats/getPublicStateStats`;
        let res1 = await fetchData(url1);
      
        if (res1.groupCounts.length > 0)
        {            
            let actives: any[] = [];
            let tx_curr_ages: any[][] = [];
            let maleCounts: number[] = [];
            let femaleCounts: number[] = [];
            let malePbs: number[] = [];    
            let femalePbs: number[] = []; 
            let percentagePbsCoverage: number[] = [];
            let categories: string[] = [];
            let drill: any[] = [];
            let drillData: any[] = [];

            // Create the chart               
            res1.groupCounts.map(function (p: { stateName: string, active: number, maleCount: number, femaleCount: number, malePbs: number, femalePbs: number, facilityData: [] })
            {
                var states = el.stateNames.filter(function (s: any)
                {
                    return s.code.toLowerCase() === p.stateName.toLowerCase();
                });

                actives.push(p.active);
                maleCounts.push(p.maleCount);
                malePbs.push(p.malePbs);
                femalePbs.push(p.femalePbs);
                femaleCounts.push(p.femaleCount);

                if (p.active > 0 && p.malePbs > 0 && p.femalePbs > 0)
                {
                    percentagePbsCoverage.push(((p.malePbs + p.femalePbs)*100)/p.active);
                }
                else
                {
                    percentagePbsCoverage.push(0);
                }

                if (states !== undefined && states.length > 0)
                {
                    categories.push(states[0].name);
                }                    
                
            });                 
    
            tx_curr_ages = res1.ageBands;

            //let colors = ['#95CEFF', '#50B432', '#24CBE5', '#ff7043', '#DDDF00', '#24CBE5',
            //    '#64E572', '#FF9655', '#FFF263', '#6AF9C4'];

            //let colors = ['#3aacae', '#50B432', '#24CBE5', '#3aacae', '#95cc3e'];

            //Render TX_CURR By State
            Highcharts.chart(
                {
                    chart:
                    {
                        renderTo: 'patient-year',
                        type: 'column'
                    },
                    title: {
                        text: 'TX_CURR Distribution By State'
                    },
                    subtitle: {
                        text: 'Disaggregated by Sex'
                    },
                    xAxis: { categories: categories, type: 'category' },
                    yAxis: {
                        min: 0,
                        title: {
                            text: 'Active Patients'
                        }
                    },
                    tooltip: {
                        headerFormat: '<table style="width: 110px"><tr style="font-size:12px; font-weight: bold; border-bottom: thin solid #ddd"><td>{point.key}</td></tr>',
                        pointFormat: '<tr style="font-size:11px;"><td style="color:{series.color};padding:0">{series.name}: </td>' +
                            '<td style="padding:0"><b>{point.y}</b><br/></td></tr>',
                        footerFormat: '</table>',
                        shared: true,
                        useHTML: true
                    },
                    plotOptions: {
                        column: {
                            shadow: false,
                            borderWidth: 0,
                        }
                    },
                    //colors: colors,
                    series: [
                        //{ name: 'Active', data: actives, type: 'column' },                        
                        { name: 'Female', data: femaleCounts, type: 'column', pointPadding: 0 },
                        { name: 'Male', data: maleCounts, type: 'column', pointPadding: 0 },
                    ]                   
            });                          

            var pbsToolTip =
            {
                headerFormat: '<table style="width: 110px"><tr style="font-size:12px; font-weight: bold; border-bottom: thin solid #ddd"><td colspan="2">{point.key}</td></tr>',
                pointFormat: '<tr style="font-size:11px;background-color: #fff"><td style="color:{series.color};padding:0">{series.name}: </td>' +
                    '<td style="padding:0"><b>{point.y:,.1f}%</b></td></tr>',
                footerFormat: '</table>',
                shared: true,
                useHTML: true
            };

            //Render PBS Coverage
            Highcharts.chart(
                {
                    chart: {
                        renderTo: 'pbs',
                        type: 'column'
                    },
                    title: {
                        text: 'PBS Coverage By State'
                    },
                    subtitle: {
                        text: 'Disaggregated by Sex'
                    },
                    xAxis: {
                        categories: categories,
                        crosshair: true
                    },
                    yAxis: [{ // Primary yAxis
                        gridLineWidth: 0,
                        minorGridLineWidth: 0,
                        labels: {
                            format: '{value}',
                            style: {
                                color: '#000'
                            }
                        },
                        title: {
                            text: 'Active Patients',
                            style: {
                                color: '#000'
                            }
                        }
                    }, { // Secondary yAxis
                        title: {
                            text: '% Covered',
                            rotation: 270,
                            style: {
                                color: '#000'
                            }
                        },
                        gridLineWidth: 0,
                        minorGridLineWidth: 0,
                        min: 0,
                        max: 100,
                        //labels: {
                        //    format: '{value}%',
                        //    style: {
                        //        color: Highcharts.getOptions().colors[1]
                        //    }
                        //},
                        opposite: true,
                        showFirstLabel: false,
                        showLastLabel: true
                    }],
                    legend: {
                        align: 'left',
                        x: 50,
                        verticalAlign: 'bottom',
                        y: 22,
                        floating: false,
                        backgroundColor: 'white',
                        borderColor: '#fff',
                        borderWidth: 0,
                        shadow: false
                    },
                    tooltip: {
                        headerFormat: '<table style="width: 110px"><tr style="font-size:12px; font-weight: bold; border-bottom: thin solid #ddd"><td colspan="2">{point.key}</td></tr>',
                        pointFormat: '<tr style="font-size:11px;background-color: #fff"><td style="color:{series.color};padding:0">{series.name}: </td>' +
                            '<td style="padding:0"><b>{point.y:,.0f}</b></td></tr>',
                        footerFormat: '</table>',
                        shared: true,
                        useHTML: true
                    },
                    plotOptions: {
                        column: {
                            borderWidth: 0,
                            grouping: false,
                            shadow: false
                        }
                    },
                    colors: ['rgb(124,181,236)', '#B4C7E7', 'rgb(67,67,72)', '#7030A0', '#4472C4'], //#7030A0
                    series: [
                        { name: 'Active', data: actives, type: 'column', pointWidth: 65, pointPadding: 0, tooltip: { valueSuffix: '' } },
                        { name: 'Female', data: femalePbs, type: 'column', pointWidth: 60, pointPadding: 0., tooltip: { valueSuffix: '' } },
                        { name: 'Male', data: malePbs, type: 'column', pointWidth: 55, pointPadding: 0.2, tooltip: { valueSuffix: '' } },
                        { name: 'PBS Coverage', data: percentagePbsCoverage, yAxis: 1, type: 'scatter', marker: { radius: 4 }, tooltip: pbsToolTip, dataLabels: { enabled: true, format: '{point.y:,.1f}%' } }
                    ]
                });

            //Render age band Aggregate data on Pie chart
            Highcharts.chart(
            {
                chart:
                {
                    renderTo: 'pie-agg',
                    plotShadow: false,
                    type: 'pie'
                },
                title: { text: 'TX_CURR By Age band' },
                credits: { enabled: false },
                exporting: { enabled: false },
                tooltip: {
                    pointFormat: 'total: {point.y} ({point.percentage:.1f}%)'
                },
                plotOptions:
                {
                    pie:
                    {
                        dataLabels:
                        {
                            enabled: true,
                            format: '<b>{point.y}({point.percentage:.1f} %)',
                        },
                        showInLegend: true
                    }
                },
                series: [{
                    innerSize: '50%',
                    data: tx_curr_ages,
                    type: 'pie'
                }]
            });   
            
        }

        this.getAgeGenderBand();
    }

    async getAgeGenderBand()
    {
        var url2 = `/api/Stats/getPublicTxCurrBands`;       
        let res2 = await fetchData(url2);
        this.setState({ loading: false });

        this.activityWatcher();

        let el = this;

        if (res2.length > 0)
        {
            let males: number[] = [];
            let females: number[] = [];

            //Caching these items is necessary for later use in the 'age-gender queries (linelist)' page
            localStorage.removeItem('ageSexAggregations');
            localStorage.setItem('ageSexAggregations', JSON.stringify(res2));

            let genderGroups = await el.groupBy(res2, 'groupName');

            Object.keys(genderGroups).forEach(key => {
                let ll = genderGroups[key];
                let f = 0;
                let m = 0;
                ll.map(function (p: any)
                {
                    if (p.gender.toLowerCase() === "female") f += p.ageCount;
                    if (p.gender.toLowerCase() === "male") m += p.ageCount;
                });

                females.push(-f);
                males.push(m);
            });

            var categories =
            [
                '0-4', '5-9', '10-14', '15-19',
                '20-24', '25-29', '30-34', '35-39', '40-44',
                '45-49', '50+ '
            ];

            Highcharts.chart(
                {
                    chart: {
                        renderTo: 'band',
                        type: 'bar'
                    },
                    title:
                    {
                        useHTML: true,
                        text: 'TX_CURR Disagrgregated by Age and Sex'
                    },
                    subtitle: {
                        text: 'Active Clients (+28 Days)'
                    },
                    xAxis: [{
                        categories: categories,
                        reversed: false,
                        labels: {
                            step: 1
                        }
                    }, { // mirror axis on right side
                        opposite: true,
                        reversed: false,
                        categories: categories,
                        linkedTo: 0,
                        labels: {
                            step: 1
                        }
                    }],
                    yAxis: {
                        title: {
                            text: null
                        },
                        labels:
                        {
                            formatter: function (val)
                            {
                                return Math.abs(parseFloat(val.value.toString())).toString();
                            }
                        }
                    },

                    plotOptions: {
                        series: {
                            stacking: 'normal'
                        }
                    },

                    tooltip: {
                        formatter: function ()
                        {
                            let nmb: number = this.point.y !== undefined? this.point.y : 0;
                            return '<b>' + this.series.name + ', age ' + this.point.category + '</b><br/>' +
                                'No. of Clients: ' + nmb !== undefined? (Highcharts.numberFormat(Math.abs(nmb), 0)).toString(): '0';
                        }
                    },

                    series: [{
                        name: 'Male',
                        data: males,
                        type: 'bar'
                    }, {
                        name: 'Female',
                            data: females,
                            type: 'bar'
                    }]
                });
        }
    }

    async groupBy(array: any[], property: string)
    {
        return array.reduce(function (accumulator, object)
        {
            // get the value of the object(gender in this case) to use to group the array as the array key   
            const key = object[property];
            // if the current value is similar to the key(gender) don't accumulate the transformed array and leave it empty  
            if (!accumulator[key]) {
                accumulator[key] = [];
            }
            // add the value to the array
            accumulator[key].push(object);
            // return the transformed array
            return accumulator;
            // Also we also set the initial value of reduce() to an empty object
        }, {});
    } 

    redirect()
    {
        this.setState({ redirect: true });
    }

    render()
    {
        const { dashboard, loading } = this.state;
        let user = this.props.appUser;
        let userState = "";
        if (user.stateCode && user.stateCode.length > 0)
        {
            var states = this.stateNames.filter(s =>
            {
                return s.code.toLocaleLowerCase() === user.stateCode.toLocaleLowerCase();
            });

            if (states.length > 0)
            {
                userState = states[0].name;
            }
        }
        //'#f0f2f5'

        return <div className="dashboard" style={{ backgroundColor: 'rgb(240, 242, 245, 0.15)' }}>
                <Helmet>
                    <title>CDR | Dashboard</title>
            </Helmet>
            {loading && <img className="waiter" src={busyGif} alt="" style={{ width: '54px', height: '54px' }} />}           
            <Row className="row-30px-pad-10px-top" style={{ paddingTop: '10px' }}>
                <Col span={10} className="stat-card">
                    <h4 style={{ fontWeight: 'bold', fontSize: '17px' }}> {userState && userState.length > 0 ? userState + " State's " : ''} TX Indicators [* AS AT TODAY] </h4>
                </Col>
                <Col span={6}>
                    <h4>CDR | Dashboard</h4>
                </Col>
                <Col span={8}>
                    {dashboard.sites && <h4 style={{ float: 'right', marginRight: '20px' }}>Facilities: <span style={{ fontWeight: 'bold', fontSize: '22px' }} className="db-h3-t">{String(dashboard.sites.filter(function (s: any) { return s.hasClients > 0 }).length).replace(/(.)(?=(\d{3})+$)/g, '$1,')}</span></h4>}
                </Col>
            </Row> 
                <Row className="sr row-30px-pad-10px-top">
                    <Col xs={24} sm={12} md={12} lg={12} xl={6} className="stat-card">
                        <Card className="ant-card-body pfs s-list">
                            <div className="custom-image">
                            <h3 className="db-h3 db-h3-i">{String(dashboard.active).replace(/(.)(?=(\d{3})+$)/g, '$1,')}</h3>
                            </div>
                        {/*<TeamOutlined className="db-i" />*/}
                        <svg className="bi bi-people db-i" width="1em" height="1em" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                <path fillRule="evenodd" d="M15 14s1 0 1-1-1-4-5-4-5 3-5 4 1 1 1 1h8zm-7.995-.944v-.002.002zM7.022 13h7.956a.274.274 0 00.014-.002l.008-.002c-.002-.264-.167-1.03-.76-1.72C13.688 10.629 12.718 10 11 10c-1.717 0-2.687.63-3.24 1.276-.593.69-.759 1.457-.76 1.72a1.05 1.05 0 00.022.004zm7.973.056v-.002.002zM11 7a2 2 0 100-4 2 2 0 000 4zm3-2a3 3 0 11-6 0 3 3 0 016 0zM6.936 9.28a5.88 5.88 0 00-1.23-.247A7.35 7.35 0 005 9c-4 0-5 3-5 4 0 .667.333 1 1 1h4.216A2.238 2.238 0 015 13c0-1.01.377-2.042 1.09-2.904.243-.294.526-.569.846-.816zM4.92 10c-1.668.02-2.615.64-3.16 1.276C1.163 11.97 1 12.739 1 13h3c0-1.045.323-2.086.92-3zM1.5 5.5a3 3 0 116 0 3 3 0 01-6 0zm3-2a2 2 0 100 4 2 2 0 000-4z" clipRule="evenodd" />
                            </svg>
                            <div className="custom-card" title="View more">
                                <h3>TX_CURR (+28 days)&nbsp;</h3>
                            </div>
                        </Card>
                    </Col>              
                    <Col xs={24} sm={12} md={12} lg={12} xl={6} className="stat-card">
                        <Card className="ant-card-body pfs s-list">
                            <div className="custom-image">
                            <h3 className="db-h3 db-h3-g">{String(dashboard.newPatients).replace(/(.)(?=(\d{3})+$)/g, '$1,')}</h3>
                            </div>
                        {/*<UsergroupAddOutlined className="db-i" />*/}
                        <svg className="bi bi-person-plus db-i" width="1em" height="1em" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                            <path fillRule="evenodd" d="M11 14s1 0 1-1-1-4-6-4-6 3-6 4 1 1 1 1h10zm-9.995-.944v-.002.002zM1.022 13h9.956a.274.274 0 00.014-.002l.008-.002c-.001-.246-.154-.986-.832-1.664C9.516 10.68 8.289 10 6 10c-2.29 0-3.516.68-4.168 1.332-.678.678-.83 1.418-.832 1.664a1.05 1.05 0 00.022.004zm9.974.056v-.002.002zM6 7a2 2 0 100-4 2 2 0 000 4zm3-2a3 3 0 11-6 0 3 3 0 016 0zm4.5 0a.5.5 0 01.5.5v2a.5.5 0 01-.5.5h-2a.5.5 0 010-1H13V5.5a.5.5 0 01.5-.5z" clipRule="evenodd" />
                            <path fillRule="evenodd" d="M13 7.5a.5.5 0 01.5-.5h2a.5.5 0 010 1H14v1.5a.5.5 0 01-1 0v-2z" clipRule="evenodd" />
                        </svg>
                            <div className="custom-card">
                            <h3>TX_NEW (In current Quarter)&nbsp;</h3>
                            </div>
                        </Card>
                </Col>
                    <Col xs={24} sm={12} md={12} lg={12} xl={6} className="stat-card">
                        <Card className="ant-card-body pfs s-list">
                            <div className="custom-image">
                                <h3 className="db-h3 db-h3-n">{String(dashboard.eligible).replace(/(.)(?=(\d{3})+$)/g, '$1,')}</h3>
                            </div>
                        {/*<SolutionOutlined className="db-i" />*/}
                            <svg className="bi bi-list-ol db-i" width="1em" height="1em" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                <path fillRule="evenodd" d="M5 11.5a.5.5 0 01.5-.5h9a.5.5 0 010 1h-9a.5.5 0 01-.5-.5zm0-4a.5.5 0 01.5-.5h9a.5.5 0 010 1h-9a.5.5 0 01-.5-.5zm0-4a.5.5 0 01.5-.5h9a.5.5 0 010 1h-9a.5.5 0 01-.5-.5z" clipRule="evenodd" />
                                <path d="M1.713 11.865v-.474H2c.217 0 .363-.137.363-.317 0-.185-.158-.31-.361-.31-.223 0-.367.152-.373.31h-.59c.016-.467.373-.787.986-.787.588-.002.954.291.957.703a.595.595 0 01-.492.594v.033a.615.615 0 01.569.631c.003.533-.502.8-1.051.8-.656 0-1-.37-1.008-.794h.582c.008.178.186.306.422.309.254 0 .424-.145.422-.35-.002-.195-.155-.348-.414-.348h-.3zm-.004-4.699h-.604v-.035c0-.408.295-.844.958-.844.583 0 .96.326.96.756 0 .389-.257.617-.476.848l-.537.572v.03h1.054V9H1.143v-.395l.957-.99c.138-.142.293-.304.293-.508 0-.18-.147-.32-.342-.32a.33.33 0 00-.342.338v.041zM2.564 5h-.635V2.924h-.031l-.598.42v-.567l.629-.443h.635V5z" />
                            </svg>
                            <div className="custom-card" title="View more">
                            <h3>Eligible for PVLS within Last 12 months&nbsp;</h3>
                            </div>
                        </Card>
                    </Col>
                    <Col xs={24} sm={12} md={12} lg={12} xl={6} className="stat-card">
                        <Card className="ant-card-body pfs s-list">
                            <div className="custom-image">
                                <h3 className="db-h3 db-h3-b">{String(dashboard.suppressed).replace(/(.)(?=(\d{3})+$)/g, '$1,')}</h3>
                            </div>
                        {/*<CarryOutOutlined className="db-i"/>*/}
                        <svg className="bi bi-person-check db-i" width="1em" height="1em" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                <path fillRule="evenodd" d="M11 14s1 0 1-1-1-4-6-4-6 3-6 4 1 1 1 1h10zm-9.995-.944v-.002.002zM1.022 13h9.956a.274.274 0 00.014-.002l.008-.002c-.001-.246-.154-.986-.832-1.664C9.516 10.68 8.289 10 6 10c-2.29 0-3.516.68-4.168 1.332-.678.678-.83 1.418-.832 1.664a1.05 1.05 0 00.022.004zm9.974.056v-.002.002zM6 7a2 2 0 100-4 2 2 0 000 4zm3-2a3 3 0 11-6 0 3 3 0 016 0zm6.854.146a.5.5 0 010 .708l-3 3a.5.5 0 01-.708 0l-1.5-1.5a.5.5 0 01.708-.708L12.5 7.793l2.646-2.647a.5.5 0 01.708 0z" clipRule="evenodd" />
                            </svg>
                            <div className="custom-card">
                                <h3>Virally Suppressed within Last 12 months</h3>
                            </div>
                        </Card>
                    </Col>                       
                </Row>
            <Col span={24} style={{marginTop: '30px'}}></Col>
            <Row gutter={2} className="row-30px-pad-10px-top state-txcurr" >
                <Col className="ant-card-bordered" xs={24} sm={24} md={12} lg={12} xl={12} id="patient-year"></Col>
                <Col span={1}></Col>
                <Col className="ant-card-bordered" xs={24} sm={24} md={11} lg={11} xl={11} id="pbs"></Col>
            </Row>
            <Row gutter={2} className="row-30px-pad-10px-top top-20px state-txcurr">
                <Col span={24}></Col>
                <Col className="ant-card-bordered" xs={24} sm={24} md={17} lg={17} xl={17} id="band"></Col>
                <Col span={1}></Col>
                <Col className="ant-card-bordered" xs={24} sm={24} md={6} lg={6} xl={6} id="pie-agg"></Col>
            </Row>
        </div>;
        
    }
}

export default connect(
    (state: ApplicationState) => state.auth, // Selects which state properties are merged into the component's props
    AuthStore.actionCreators // Selects which action creators are merged into the component's props
)(Dashboard as any);



//function values<T>(x: T) {
//    const keys = Object.keys(x) as (keyof T)[];
//    return keys.map(s => x[s]);
//}